/**
 * @format
 */

import * as actionTypes from './actionTypes';
import { Dispatch } from 'redux';

export type ApiError = {
  detail?: string;
  userMessage?: string;
  [key: string]: any;
};

function publishErrorAction(actionId: string, error: ApiError) {
  return {
    type: actionTypes.PUBLISH_ERROR,
    actionId: actionId,
    error: error,
  };
}

function clearErrorAction(actionId: string) {
  return {
    type: actionTypes.CLEAR_ERROR,
    actionId: actionId,
  };
}

function clearAllErrorsAction() {
  return {
    type: actionTypes.CLEAR_ALL_ERRORS,
  };
}

// EXPORTS

export function publishError(actionId: string, error: ApiError) {
  return function (dispatch: Dispatch) {
    dispatch(publishErrorAction(actionId, error));
  };
}

export function clearError(actionId: string) {
  return function (dispatch: Dispatch) {
    dispatch(clearErrorAction(actionId));
  };
}

export function clearAllErrors() {
  return function (dispatch: Dispatch) {
    dispatch(clearAllErrorsAction());
  };
}
